import { createSlice } from '@reduxjs/toolkit'

const mapProviderList = list => {
  if (!list) {
    return []
  }
  const providers = []
  for (const [, provider] of Object.entries(list)) {
    const data = {
      label: provider.name,
      uuid: provider.uuid,
    }
    providers.push(data)
  }
  return providers
}

export const initialState = {
  initialized: false,
  save: {
    loading: false,
  },
  errors: {},
  general: {
    providersList: [],
    title: '',
  },
  routes: {
    providerInformation: '',
    store: '',
    update: '',
    delete: '',
  },
  selectedProvider: {
    uuid: '',
    apiIntegration: 0,
  },
  selectedOffer: {
    id: 0,
  },
  viewParameters: {
    parametersLoaded: false,
  },
  comparators: [],
}

const slice = createSlice({
  name: 'organizationsManagement',
  initialState,
  reducers: {
    initialize: (state, { payload }) => {
      state.initialized = true
      state.routes = { ...(payload.routesSpa ?? {}) }
      state.general = {
        providersList: mapProviderList(payload.organisations ?? []),
        title: payload.title,
      }
    },
    setViewParameters: (state, { payload }) => {
      state.viewParameters = {
        parametersLoaded: true,
        ...(payload ?? {}),
      }
    },
    setProvider: (state, { payload }) => {
      state.selectedProvider = {
        ...(payload ?? {}),
        apiIntegration: payload.api_workflow && payload.api_workflow.length > 0 ? 1 : 0,
      }
    },
    updateProvider: (state, { payload }) => {
      Object.assign(state.selectedProvider, payload ?? {})
    },
    setErrors: (state, { payload }) => {
      state.errors = { ...(payload ?? {}) }
    },
    saving: (state, { payload }) => {
      Object.assign(state.save, payload ?? {})
    },
    reset: state => {
      state.selectedProvider = {
        uuid: '',
      }
    },
    setOffer: (state, { payload }) => {
      state.selectedOffer = { ...(payload ?? {}) }
    },
    updateOffer: (state, { payload }) => {
      Object.assign(state.selectedOffer, payload ?? {})
    },
    resetOffer: state => {
      state.selectedOffer = {
        uuid: '',
        active: true,
      }
    },
    setComparators: (state, { payload }) => {
      state.comparators = payload ?? []
    },
    addComparator: (state, { payload }) => {
      state.comparators.push(payload)
    },
    removeProvider: (state, { payload: providerId }) => {
      state.general.providersList = state.general.providersList.filter(p => p.uuid !== providerId)
      if (state.selectedProvider.uuid === providerId) {
        state.selectedProvider = { uuid: '', apiIntegration: 0 }
      }
    },
  },
})

export const {
  initialize,
  setViewParameters,
  setProvider,
  updateProvider,
  setErrors,
  saving,
  reset,
  setOffer,
  updateOffer,
  resetOffer,
  setComparators,
  addComparator,
  removeProvider,
} = slice.actions

export default slice.reducer
